import { Target } from "lucide-react";
import { cn } from "@/lib/utils";
import { WEBSITE_GOALS, type LeadFormData } from "../types";

interface Props {
  data: LeadFormData;
  onChange: (patch: Partial<LeadFormData>) => void;
}

const MAX_GOALS = 2;

export function StepGoal({ data, onChange }: Props) {
  const selectedGoals = data.websiteGoal ?? [];

  const toggle = (goal: string) => {
    const exists = selectedGoals.includes(goal);
    if (exists) {
      onChange({ websiteGoal: selectedGoals.filter((g) => g !== goal) });
      return;
    }
    if (selectedGoals.length >= MAX_GOALS) return;
    onChange({ websiteGoal: [...selectedGoals, goal] });
  };

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue">
          <Target className="h-4 w-4" />
          Website Goal
        </div>
        <h2 className="text-balance text-3xl font-bold tracking-tighter text-foreground sm:text-4xl">
          What's the main job of your website?
        </h2>
        <p className="text-base text-muted-foreground">
          Pick up to 2 — most websites do more than one thing.
        </p>
        <p className="text-sm font-medium text-brand-blue">
          {selectedGoals.length} of {MAX_GOALS} selected
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {WEBSITE_GOALS.map((goal) => {
          const selected = selectedGoals.includes(goal);
          const disabled = !selected && selectedGoals.length >= MAX_GOALS;
          return (
            <button
              key={goal}
              type="button"
              onClick={() => toggle(goal)}
              disabled={disabled}
              className={cn(
                "w-full rounded-xl border bg-background px-5 py-4 text-left text-sm font-medium text-gray-950 transition-all",
                "hover:border-brand-blue hover:shadow-sm",
                selected
                  ? "border-brand-blue bg-brand-blue/5 ring-2 ring-brand-blue/30"
                  : "border-border",
                disabled && "opacity-50 cursor-not-allowed hover:border-border hover:shadow-none",
              )}
            >
              {goal}
            </button>
          );
        })}
      </div>
    </div>
  );
}
